import { __decorate, __metadata } from "tslib";
import { UseRestraints } from '@core/shared/restraints';
import { EditorDefinition, Expose, IdItemModel, ItemModelDefinition, ItemModelProp, ModelId } from '@core/shared/model';
import { MediaAssetMapRestraints } from "./media-asset-mapping.restraints";
let MediaAssetMappingItem = /*#__PURE__*/(() => {
  let MediaAssetMappingItem = class MediaAssetMappingItem extends IdItemModel {
    toString() {
      return "MediaAssetMap " + this.name;
    }
  };
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: true
  }), __metadata("design:type", Boolean)], MediaAssetMappingItem.prototype, "enabled", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], MediaAssetMappingItem.prototype, "asset", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], MediaAssetMappingItem.prototype, "ordering", void 0);
  __decorate([Expose(), __metadata("design:type", String)], MediaAssetMappingItem.prototype, "consumerName", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], MediaAssetMappingItem.prototype, "consumerId", void 0);
  __decorate([Expose(), __metadata("design:type", String)], MediaAssetMappingItem.prototype, "consumerMediaSlot", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], MediaAssetMappingItem.prototype, "extra", void 0);
  MediaAssetMappingItem = __decorate([EditorDefinition({}, {
    allowAllExposed: true
  })
  // @CrudEndpoints({admin:'/admin/...'})
  , ItemModelDefinition({
    texts: {}
  }), UseRestraints(MediaAssetMapRestraints), ModelId("MediaAssetMappingItem") // auto-generated by generate-model-ids
  ], MediaAssetMappingItem);
  return MediaAssetMappingItem;
})();
export { MediaAssetMappingItem };